import React, { useState } from "react";
import OperationsPage from "./OperationsPage";
import { MonthNavigator } from "../../components/shared/Navigators";

const STATUS = ["Active", "In Discussion", "Waiting on Client", "Waiting on Lender", "Pending Closing", "Completed", "Closed", "Lost", "On Hold", "Cancelled", "Rescheduled", "No-Show"];
const PRIORITY = ["Normal", "Priority"];

const FIELDS = [
  { name: "date", label: "Date", type: "date" },
  { name: "company", label: "Company / Individual(s)" },
  { name: "email", label: "Email" },
  { name: "phone", label: "Phone" },
  { name: "type", label: "Type" },
  { name: "amount", label: "Amount", type: "number" },
  { name: "rate", label: "Rate" },
  { name: "purpose", label: "Purpose" },
  { name: "referral_source", label: "Referral Source" },
  { name: "referral_entity", label: "Referral Entity" },
  { name: "lenders", label: "Lender(s)" },
  { name: "individual", label: "Individual" },
  { name: "commission", label: "Commission", type: "number" },
  { name: "notes", label: "Notes", type: "textarea", full: true },
  { name: "expected_closing", label: "Expected Loan Closing Date", type: "date" },
  { name: "follow_up", label: "Follow Up", full: true },
  { name: "follow_up_date", label: "Follow Up Date", type: "date" },
  { name: "status", label: "Status", type: "select", options: STATUS },
  { name: "priority", label: "Priority", type: "select", options: PRIORITY },
];

const CATS = [
  { key: "Commercial Pipeline / Deals in Discussion", color: "#F76B15", fields: FIELDS },
  { key: "Residential Pipeline / Deals in Discussion", color: "#FFC53D", fields: FIELDS },
  { key: "Closed Residential", color: "#46A758", fields: FIELDS },
  { key: "Closed Commercial", color: "#46A758", fields: FIELDS },
  { key: "Lost / On Hold - Commercial", color: "#707070", fields: FIELDS },
  { key: "Lost / On Hold - Residential", color: "#707070", fields: FIELDS },
].map((c) => ({ ...c, label: c.key }));

const COLUMNS = [
  { key: "date", label: "Date", className: "font-mono-rw text-xs" },
  { key: "company", label: "Company / Individual" },
  { key: "type", label: "Type" },
  { key: "amount", label: "Amount", className: "text-right font-mono-rw tabular-nums", render: (v) => v ? `$${Number(v).toLocaleString()}` : "—" },
  { key: "rate", label: "Rate", className: "font-mono-rw text-xs" },
  { key: "commission", label: "Comm.", render: (v) => v ? `$${Number(v).toLocaleString()}` : "—", className: "text-right font-mono-rw tabular-nums" },
  { key: "lenders", label: "Lender" },
  { key: "expected_closing", label: "Expected", className: "font-mono-rw text-xs" },
  { key: "notes", label: "Notes", render: (v) => <span className="text-xs text-neutral-500 line-clamp-1">{v || "—"}</span> },
  { key: "status", label: "Status" },
  { key: "priority", label: "Priority" },
];

export default function Pipeline() {
  const now = new Date();
  const [value, setValue] = useState(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`);
  return (
    <OperationsPage
      kind="pipeline"
      title="Pipeline Report"
      eyebrow="Operations"
      dot="var(--rw-dot-pipeline)"
      description="Monthly deal pipeline — commercial, residential, closed, lost, on-hold."
      scope={{
        type: "month",
        value,
        setValue,
        Navigator: <MonthNavigator value={value} onChange={setValue} />,
      }}
      defaultCategories={CATS}
      getFieldsFor={() => FIELDS}
      columns={COLUMNS}
    />
  );
}
